
<div class="modal-content">
      
  <div class="modal-body text-center">
    <img src="assets/offline/oops.png" />
    <ng-container *ngIf="error === 'nointernet'">
      <h2>{{'LABELS.OOPS' | translate}}</h2>
      <p class="text-muted">{{ 'LABELS.SLOW_OR_NO_INTERNET' | translate}}</p>
      <p class="text-muted">{{ 'LABELS.CHECK_INTERNET_SETTINGS' | translate}}</p>
    </ng-container>
    <ng-container *ngIf="error === 'servererror'">
      <p class="text-muted">{{ 'LABELS.THERE_SEEMS_SERVER_ISSUE' | translate}}</p>
      <p class="text-muted">{{ 'LABELS.PLEASE_TRY_AFTER_SOMETIME' | translate}}</p>
    </ng-container>
    <button class="btn btn-outline-secondary fis-btn" (click)="close()">{{ 'LABELS.OK' | translate}}</button>
  </div>
</div>
